import React from "react";
import {
  Box,
  VStack,
  Text,
} from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";

const markdownComponents = {
  ul: ({ node, ...props }: any) => (
    <ul style={{ paddingLeft: "1.25rem", marginTop: "0.5rem", marginBottom: "0.5rem" }} {...props} />
  ),
  ol: ({ node, ...props }: any) => (
    <ol style={{ paddingLeft: "1.25rem", marginTop: "0.5rem", marginBottom: "0.5rem" }} {...props} />
  ),
  li: ({ node, ...props }: any) => (
    <li style={{ fontSize: "0.875rem", marginBottom: "0.25rem" }} {...props} />
  ),
  p: ({ node, ...props }: any) => (
    <p style={{ fontSize: "0.875rem", marginTop: "0.5rem", marginBottom: "0.5rem" }} {...props} />
  ),
  h1: ({ node, ...props }: any) => (
    <h1 style={{ fontSize: "1.15rem", fontWeight: "bold", margin: "1rem 0" }} {...props} />
  ),
  h2: ({ node, ...props }: any) => (
    <h2 style={{ fontSize: "1.05rem", fontWeight: "bold", margin: "0.875rem 0" }} {...props} />
  ),
  h3: ({ node, ...props }: any) => (
    <h3 style={{ fontSize: "0.95rem", fontWeight: "bold", margin: "0.75rem 0" }} {...props} />
  ),
  h4: ({ node, ...props }: any) => (
    <h4 style={{ fontSize: "0.85rem", fontWeight: "bold", margin: "0.625rem 0" }} {...props} />
  ),
};

export interface AnalysisScenarioInsightsCardProps {
  isLoading: boolean;
  lastAiContent: string | undefined;
}

const AnalysisScenarioInsightsCard: React.FC<AnalysisScenarioInsightsCardProps> = ({
  isLoading,
  lastAiContent,
}) => {
  return (
    <VStack spacing={2} align="stretch" ml={0} mr={0} mb={2}>
      <Box
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        bg="white"
        px={3}
        py={1}
      >
        {isLoading ? (
          <Text fontSize="xs" color="gray.500" mb={0}>Loading...</Text>
        ) : lastAiContent ? (
          <Text fontSize="xs" color="gray.700" lineHeight="1.6" mb={0} textAlign="left">
            <ReactMarkdown components={markdownComponents}>
              {lastAiContent}
            </ReactMarkdown>
          </Text>
        ) : (
          <Text fontSize="xs" color="gray.400" mb={0}>No output found.</Text>
        )}
      </Box>
    </VStack>
  );
};

export default AnalysisScenarioInsightsCard; 
